<p-card *ngIf="content" data-auto-id="features-benefits-card">
    <p-accordion value="0">
        <p-accordion-panel class="border-none" value="0">
            <p-accordion-header *ngIf="content">
                <div class="flex gap-2">
                    @if(type === locksmithFeaturesBenefits) {
                        <img src="assets/icons/cinch_icon_home.svg" width="45px" height="45px" alt="Locksmith house icon">
                    } @else if(handymanFeatures.includes(type)) {
                        <img src="assets/icons/cinch_icon_tools.svg" width="45px" height="45px"
                            alt="Handyman features icon">
                    } @else {
                        <img src="assets/icons/cinch_icon_wholesale_Discount.svg" width="45px" height="45px"
                            alt="Wholesale discount icon">
                    }
                    <div class="flex flex-column text-left" [ngClass]="{'justify-content-center': !content.subTitle}">
                        <p class="text-base text-slate-950 custom-bold m-0">{{content.title}}</p>
                        <p *ngIf="content.subTitle" class="m-0 text-slate-500 font-normal text-base">
                            {{content.subTitle}}</p>
                    </div>
                </div>

            </p-accordion-header>
            <p-accordion-content>
                @if(content.instructions) {
                    <div class="text-left">
                        <p class="custom-bold m-0 mb-3 text-base text-slate-950">How to:</p>
                        <ol class="m-0 pl-3 flex flex-column gap-2 text-md font-normal line-height-3">
                            @for (instruction of content.instructions; track instruction) {
                            <li>{{ instruction }}</li>
                            }
                        </ol>
                    </div>
                } @else {
                    <p class="text-slate-950 text-base font-normal line-height-3 m-0">{{content.description}}</p>
                }
                <div *ngIf="liferayContent && liferayContent.linkLabels?.[0]?.linkUrl"
                    class="mt-auto pt-4" [ngClass]="isFullWidthCard ? 'col-12 md:col-6 m-auto' : 'w-full'">
                    <p-button [rounded]="true"
                        [severity]="type === locksmithFeaturesBenefits ? 'primary' : 'secondary'"
                        [variant]="type === locksmithFeaturesBenefits ? undefined : 'outlined'"
                        label="{{ liferayContent.buttonText || (type === locksmithFeaturesBenefits ? 'Get instructions' : '') }}"
                        icon="pi pi-download" data-auto-id="features-benefits-learn-more-button" type="button"
                        class="flex align-items-center justify-content-center" styleClass="w-full"
                        (click)="openFeaturesBenefitsPdf()"></p-button>
                </div>

            </p-accordion-content>
        </p-accordion-panel>
    </p-accordion>
</p-card>